const welcome = {
    title: 'Yönetici Paneline Hoş Geldiniz',
    description: 'Yönetici paneli, kodlama bilgisi olmadan Logtoyu yönetmek için bir web uygulamasıdır. Önce, bir hesap oluşturalım. Bu hesapla Logtoyu kendiniz veya şirketiniz adına yönetebilirsiniz.',
    create_account: 'Hesap Oluştur',
};
export default welcome;
